<div *ngIf="!!userModel" class="row mb-xl-5">
  <div class="col-lg-12 title-container justify-content-center justify-content-xl-start col-xl-3 center">
    <div class="account-type-title">
      {{ 'AccountType.PurposeType.Title' | translate }}<br>
      <span [innerHTML]="'AccountType.PurposeType.SubTitle' | translate | safe:'html'" class="small"></span>
    </div>
  </div>

  <div class="col-lg-12 buttons-radiobox">
    <div class="checkbox-group">
      <mat-checkbox [(ngModel)]="userModel.purposeIndependent" [disableRipple]="true">
        <div class="button-content">
          <span>{{ 'AccountType.PurposeType.Independent.Title' | translate }}</span>

          <app-info-hint [text]="'AccountType.PurposeType.Independent.Info' | translate"></app-info-hint>
        </div>
      </mat-checkbox>

      <mat-checkbox [(ngModel)]="userModel.purposeFixed" [disableRipple]="true">
        <div class="button-content">
          <span>{{ 'AccountType.PurposeType.Fixed.Title' | translate }}</span>

          <app-info-hint [text]="'AccountType.PurposeType.Fixed.Info' | translate"></app-info-hint>
        </div>
      </mat-checkbox>
    </div>

    <div *ngIf="!userModel.purposeIndependent && !userModel.purposeFixed && this.submitted"
         [innerHTML]="'AccountType.PurposeType.Errors.Required' | translate"
         class="error">
    </div>
  </div>
</div>
